import { render } from "./CloseButton.vue?vue&type=template&id=44a9deeb&scoped=true"
import script from "./CloseButton.vue?vue&type=script&lang=js"
export * from "./CloseButton.vue?vue&type=script&lang=js"

import "./CloseButton.vue?vue&type=style&index=0&id=44a9deeb&scoped=true&lang=css"

import exportComponent from "/Users/muftaua/Documents/dev/CCD-Stuff/web-ccd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44a9deeb"]])

export default __exports__